module.exports = __webpack_public_path__ + "static/media/pure-natural.65a5fe3c.svg";